module.exports = __webpack_public_path__ + "static/media/TJ-CommContainer.e6cae489.svg";